import React, { Component } from 'react';
import axios from 'axios';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import services from '@C/Director/Utils/_utils/data';
import { TableGrid } from '@C/TableGrid';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';
import { authHeader } from '@H';

const col = [
  {
    name: 'OMC',
    key: 'omc',
  },
  {
    name: 'Mobile Logo',
    key: 'all',
    formatter: (props) => {
      const logoUrl = props.mobile_logo;
      return (
        <>
          {logoUrl && (
            <img
              src={logoUrl}
              alt="mobile Logo"
              style={{ width: '4rem', height: '100%' }}
            />
          )}
        </>
      );
    },
  },
  {
    name: 'Web Logo',
    key: 'all',
    formatter: (props) => {
      const logoUrl = props.web_logo;
      return (
        <>
          {logoUrl && (
            <img
              src={logoUrl}
              alt="web Logo"
              style={{ width: '4rem', height: '100%' }}
            />
          )}
        </>
      );
    },
  },
];

const enabledActions = [
  {
    action: 'Delete',
    roles: ['DIRECTOR'],
  },
  // {
  //   action: 'Edit',
  //   roles: ['DIRECTOR'],
  // },
];

export default class OMCDataList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      OMCList: [],
      loading: true,
      limit: 20,
      offset: 1,
      count: 0,
    };
    this.limitInput = React.createRef();
  }

  componentDidMount() {
    this.getOMCList();
  }

  getOMCList = () => {
    services
      .getOMCList()
      .then((response) => {
        this.setState({
          OMCList: response.data.data,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  confirmDelete = (item) => {
    confirmAlert({
      title: 'Confirm OMC deletion',
      message: (
        <div>
          Are you sure you want to delete the <span>"{item.omc}"</span>
        </div>
      ),
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.deleteItem(item),
        },
        {
          label: 'No',
          onClick: () => false,
        },
      ],
    });
  };

  deleteItem = (item) => {
    const headers = authHeader();
    axios
      .delete(`${process.env.API_URL}/bunk/omc/omc-set/?omc_id=${item.uuid}`, {
        headers,
      })
      .then(() => {
        toast.success('OMC deleted successfully', {
          position: 'bottom-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
        this.getOMCList();
      });
  };

  render() {
    const { OMCList } = this.state;
    return (
      <section className="widget full-width list-table">
        <header>
          <h3>OMC List</h3>
        </header>
        <main className="list-content">
          <div className="table-wrapper">
            {this.state.loading ? (
              <DropLoaderLarge />
            ) : (
              <TableGrid
                col={col}
                row={OMCList}
                pagination="disabled"
                enableExport={false}
                onEdit={this.props.onEdit}
                onDelete={this.confirmDelete}
                enabledActions={enabledActions}
              />
            )}
          </div>
        </main>
      </section>
    );
  }
}
